// extracted by mini-css-extract-plugin
module.exports = {"container":"navbar_container__eS3cl","item":"navbar_item__23x0z","placeholder":"navbar_placeholder__se-Iy","selected":"navbar_selected__3dlyb"};